// extracted by mini-css-extract-plugin
export default {"calendar":"DatePicker_calendar__4jLwi"};